import { Skeleton } from "primereact/skeleton";
import { themeClasses } from "sj-ui-toolkit/src/atlas/utils";

interface MetricsRowProps {
  metrics: { averageScore: string; averageTimeSpent?: string; completionRate: string };
  isLoading: boolean;
}

type MetricsKey = keyof MetricsRowProps["metrics"];

const METRIC_KEYS: MetricsKey[] = ["averageScore", "averageTimeSpent", "completionRate"];

const METRIC_LABELS: Record<MetricsKey, string> = {
  averageScore: "Average Score",
  averageTimeSpent: "Average Time Spent",
  completionRate: "Completion Rate",
};

const GRID_COLS: Record<number, string> = {
  1: "grid-cols-1",
  2: "grid-cols-2",
  3: "grid-cols-3",
};

export default function MetricsRow({ metrics, isLoading }: MetricsRowProps) {
  const visibleKeys = METRIC_KEYS.filter(key => metrics[key] !== undefined);
  const gridClass = GRID_COLS[visibleKeys.length] ?? "grid-cols-3";

  return (
    <div className={`w-1/2 grid ${gridClass} gap-4 mb-10`}>
      {visibleKeys.map(key => (
        <div key={key}>
          {isLoading ? (
            <>
              <Skeleton width="60%" className="mb-2" />
              <Skeleton width="80%" height="2rem" />
            </>
          ) : (
            <>
              <h3 className={`body-sm ${themeClasses.textSecondary}`}>{METRIC_LABELS[key]}</h3>
              <div className="text-2xl font-bold mt-2">{metrics[key] as string}</div>
            </>
          )}
        </div>
      ))}
    </div>
  );
}
